<template lang="pug">
header#header-nav.mgmt(:class="isMobile ? 'vertical' : 'horizontal'")
    nav: ul
        a.no-line
            li
                router-link.no-line(:to="{name: 'scheduling'}"): img(:src="CanineLogo")
                Hamburger(v-if="isMobile" v-model:opened="openNav")
        template(v-if="!isMobile || openNav")
            router-link(v-for="item in navMenuRoutes" :key="item.path" :to="{name: item.name}")
                li.item {{ item.name }}
            a(:class="{'router-link-active': false}" @click="openDropdown = true" @mouseleave="openDropdown = false")
                li.item.account Account
                ul.dropdown(v-if="openDropdown" @click.stop)
                    router-link(:to="{name: 'account'}"): li Settings
                    a: li(@click="logout") Logout
</template>
<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useAuth } from "../store/auth";
import router, {
	navMenuRoutes
} from "../router";
import CanineLogo from '@/resources/images/Canine-Revolution-Logo-white-1.png';
import Hamburger from "./hamburger.vue";

const auth = useAuth();

const openDropdown = ref(false);
const openNav = ref(false);

const mediaQuery = ref<MediaQueryList>(matchMedia('(max-width: 800px)'));
const isMobile = ref(mediaQuery.value.matches);
function onMobileChange(ev: MediaQueryListEvent) {
	isMobile.value = ev.matches;
}
onMounted(() => {
	mediaQuery.value.addEventListener('change', onMobileChange);
});
onUnmounted(() => {
	mediaQuery.value.removeEventListener('change', onMobileChange);
});
onUnmounted(router.afterEach(() => {
	openDropdown.value = false;
	openNav.value = false;
}));

const logout = async() =>{
	await auth.signOut();
	router.push('/auth');
};


</script>